orders-planner-line-ui-schedules-cell-uneditable(onMouseOver="{onOver}" onMouseOut="{onOut}")
  span.dmy-memo
  span.drag(onMouseDown="{onDown}")
  script(type="typescript").
    this.mixin('orders.planner.line-ui.schedules-cell-uneditable')
